import { Form, type FormInstance, type FormProps } from "antd"
import { useLayoutEffect, useState } from "react"

import { type ReactChild } from "#customTypes/globalTypes"

interface FormWithValuesProps<Values> extends FormProps<Values> {
  form: FormInstance<Values>
  // Antd Form doesn't accept null
  initialValues?: Partial<Values> | undefined
  children: ReactChild
}

// WIP - trying to get around the Antd issue with loading initialValues.
// Seem to have gotten past it with resetFields() but that's a hack. Better to load all values before rendering form.
export function FormWithValues<Values extends object>({
  form,
  initialValues = {},
  children,
  ...rest
}: FormWithValuesProps<Values>) {
  const [isMounted, setIsMounted] = useState(false)

  useLayoutEffect(() => {
    if (!isMounted && form?.resetFields) {
      form.resetFields()
      setIsMounted(true)
    }
  }, [form, initialValues, isMounted])

  return (
    <Form form={form} initialValues={initialValues} {...rest}>
      {children}
    </Form>
  )
}

export default FormWithValues
